import { useEffect } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import { Loader } from "@components";
import { useLocation, useNavigate } from "react-router-dom";
import { useLocalStorage, LocalStorageKey } from "@helpers/localStorageHelper";
import { LoginRedirect } from "@store/generalTypes";
import { NavItems } from "@helpers/navigation";

export const Login = (): JSX.Element => {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [, setLoginRedirect] = useLocalStorage<LoginRedirect>(LocalStorageKey.LoginRedirect);
    const { pathname } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const loginRedirect = async (): Promise<void> => {
            await instance.loginRedirect(loginRequest);
        };

        if (isAuthenticated) {
            navigate(NavItems.Main.Root.path);
            return;
        }

        void loginRedirect();
        if (!pathname.includes("login")) {
            setLoginRedirect({ pathname });
        }
    }, [isAuthenticated]);

    return <Loader />;
};

export default Login;
